var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Grid",
    _vm._b(
      {
        ref: "grid",
        staticClass: "kendo-grid",
        class: {
          clickable: _vm.isRowClickable,
          highlightOnHover: _vm.highlightOnHover,
          highlightOnSelect: _vm.highlightOnSelect
        },
        style: { height: "auto" },
        attrs: {
          "data-items": _vm.rows,
          columns: _vm.columns,
          resizable: "",
          scrollable: _vm.scrollable,
          "expand-field": "$expanded",
          detail: _vm.detail,
          sortable: _vm.sortable,
          sort: _vm.sort,
          pageable: _vm.pageable,
          pageSize: _vm.pageSize,
          skip: _vm.getSkip(),
          total: _vm.total,
          cellRender: _vm.customCell ? _vm.customCell : _vm.cellRender,
          groupable: _vm.groupable,
          group: _vm.group,
          toolbarHeader: ""
        },
        on: {
          expandchange: _vm.expandChange,
          rowclick: _vm.onRowClick,
          pagechange: _vm.onPageChange,
          sortchange: _vm.onSortChange,
          selectionchange: _vm.onSelectionChange,
          headerselectionchange: _vm.onHeaderSelectionChange,
          datastatechange: function($event) {
            return _vm.$emit("dataStateChange", $event)
          }
        },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.$scopedSlots, function(_, name) {
              return {
                key: name,
                fn: function(slotData) {
                  return [_vm._t(name, null, null, slotData)]
                }
              }
            })
          ],
          null,
          true
        )
      },
      "Grid",
      _vm.$attrs,
      false
    ),
    [
      _c("GridNoRecords", [
        _vm.loading
          ? _c("div", { staticClass: "norecords-loading" })
          : _c(
              "span",
              [
                _vm._t("noRecords", function() {
                  return [_vm._v(_vm._s(_vm.noRecordsMsg))]
                })
              ],
              2
            )
      ]),
      _vm.addNew
        ? _c(
            "GridToolbar",
            [
              _c(
                "Box",
                { attrs: { display: "flex", flexAlign: "center" } },
                [
                  _vm.toolbarHeader
                    ? _c(
                        "Box",
                        { attrs: { marginLeft: 2 } },
                        [
                          _c(
                            "layoutText",
                            {
                              attrs: {
                                color: "#333",
                                fontSize: 2,
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v(_vm._s(_vm.toolbarHeader))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "grid-add-link",
                      attrs: { title: "Add new" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("addNew")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.addNew))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }